'use strict';

module.exports = require('es-object-atoms/RequireObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2021/RequireObjectCoercible.js
// module id = DTIk
// module chunks = 78